import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import '../../styles/Pages.css';
import '../../styles/Events.css';

function EventsPage() {
    const [polls, setPolls] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
        fetch(`${process.env.REACT_APP_API_URL}/api/polls`)
            .then(r => r.json())
            .then(data => {
                if (data.success) setPolls(data.polls);
                else setError(data.message);
            })
            .catch(() => setError('Failed to load events. Please try again.'))
            .finally(() => setLoading(false));
    }, []);

    const timeLeft = (endTime) => {
        const diff = new Date(endTime) - new Date();
        if (diff <= 0) return 'Closed';
        const h = Math.floor(diff / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        if (h > 24) return `${Math.floor(h / 24)}d ${h % 24}h left`;
        return `${h}h ${m}m left`;
    };

    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <h1>🎉 Events & Polls</h1>
                <p>Participate in live college polls and farewell award voting!</p>
            </div>
            <div className="page-content">
                {loading && (
                    <div className="events-loading">
                        <div className="events-spinner"></div>
                        <p>Loading active polls…</p>
                    </div>
                )}
                {error && <div className="events-error">{error}</div>}
                {!loading && !error && polls.length === 0 && (
                    <div className="events-empty">
                        <span>🗳️</span>
                        <h3>No Active Polls Right Now</h3>
                        <p>Check back soon — polls will appear here when they go live!</p>
                    </div>
                )}
                {polls.length > 0 && (
                    <>
                        <h2 className="events-section-title">🔴 Live Polls — Cast Your Vote</h2>
                        <div className="polls-grid">
                            {polls.map(poll => (
                                <div key={poll._id} className="poll-card">
                                    <div className="poll-card-badge">
                                        {poll.category || 'Farewell'}
                                    </div>
                                    <h3 className="poll-card-title">{poll.title}</h3>
                                    {poll.description && (
                                        <p className="poll-card-desc">{poll.description}</p>
                                    )}
                                    <div className="poll-card-meta">
                                        <span className="poll-timer">⏰ {timeLeft(poll.endTime)}</span>
                                    </div>
                                    <Link to={`/events/poll/${poll._id}`} className="poll-vote-btn">
                                        Vote Now →
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>
            <Footer />
        </div>
    );
}

export default EventsPage;
